import React from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '../../front/Plans/Card';
import AppTypography from '../../core/Typography/AppTypography';
import { PLANS } from '../routing';
import { useStyles as useBusinessStyles } from './BusinessList';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: theme.spacing(2),
    marginBottom: '0 !important',
    width: '100%',
    fontWeight: 'bold',
    '&:hover': {
      color: theme.palette.primary.contrastText,
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(3),
    },
  },
}));

const PlanList = ({ plans = [], isAuthenticated }) => {
  const classes = useStyles();
  const businessClasses = useBusinessStyles();
  return (
    <div>
      {plans.length > 0 && (
        <>
          <AppTypography
            size={{ xs: 18, sm: 24 }}
            color="textPrimary"
            weight="bold"
            mb={2}
          >
            飛騨市のおてつたび
          </AppTypography>
          <Grid container spacing={2}>
            {plans.map((plan, idx) => (
              <Grid item xs={6} sm={4} md={3} lg={2} key={idx}>
                <Card {...plan} isAuthenticated={isAuthenticated} />
              </Grid>
            ))}
          </Grid>
          <div className={businessClasses.container}>
            <Button
              variant="contained"
              color="primary"
              href={PLANS + '?feature=hida'}
              className={clsx(classes.button, businessClasses.button)}
            >
              飛騨市のおてつたび一覧はこちら
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default PlanList;
